import { IMenu } from '@/types/menu';
import { Item } from '@/types/index';
import _find from 'lodash.find';

export const _traverse = (node: IMenu, prefix = '') => {
  if (node.pattern) {
    node.path = `${prefix}/${node.pattern}`;
  }
  if (node.subs) {
    node.subs.forEach((sub) => _traverse(sub, node.path));
  }
};

export const _transformKeys = (item: Item) => {
  const obj = {};
  item.keys.forEach((key) => {
    obj[key.pattern] = key.value;
  });
  return obj;
};

export const addPagePath = (pages: IMenu[]) => {
  pages.forEach((page) => _traverse(page));
};

export const getPageByPath = (pages: IMenu[], path = '/'): IMenu => {
  const firstPattern = path.split('/')[1];
  const newPath = `/${path
    .split('/')
    .slice(2)
    .join('/')}`;
  const page = _find(pages, { pattern: firstPattern });
  if (!page) {
    return pages[0];
  }
  if ((page && newPath === '/') || page.subs.length === 0) {
    return page;
  }
  return getPageByPath(page.subs, newPath);
};
